import { Sections } from '../types';
import { withPayloadType } from 'utils';
import { createAction } from '@reduxjs/toolkit';

export const updateSectionStart = createAction(
  'UPDATE_SECTION::START',
  withPayloadType<{ section: Sections; sectionId: string }>(),
);
